module.exports = __webpack_public_path__ + "media/stockholm/subway_star-a315e21d.jpg";